import React from 'react';
import PropTypes from 'prop-types';
import styled from 'styled-components';

import { Delete } from '@components/Icons';

const Container = styled.div`
  position: absolute;
  top: 0;
  z-index: 11;
  margin: ${({ theme }) => theme.spacing(4)};
`;

function Close({ onClick }) {
  return (
    <Container onClick={onClick}>
      <Delete size="large" />
    </Container>
  );
}

Close.propTypes = {
  onClick: PropTypes.func.isRequired,
};

export default Close;
